module.exports = __webpack_public_path__ + "static/img/9bg_2.a55d5f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_2.png
// module id = 774
// module chunks = 1